import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      name: 'msvalidate.01',
      content: {
        content: '2FED58C6BF89816D8F1D9E54BD4694CE'
      }
    },
    component: () => import("../views/home/index"),
  },
  
  
  
  //404页面
  {
    path: "/notFound", //匹配未定义的路由
    name: "notFound",
    component: () => import("../views/notFound/index"),
  },
  {
    path: "*",
    redirect: "/notFound",
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return { y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.content && to.meta.content.keywords) {
    const head = document.getElementsByTagName('head');
    const meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords);
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description);
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  if (to.meta.name) {
    // 使用 window.onload 监听所有内容加载完毕
    let metaElement = document.createElement('meta');
    metaElement.setAttribute('name', 'msvalidate.01');
    metaElement.setAttribute('content', '2FED58C6BF89816D8F1D9E54BD4694CE');
    setTimeout(() => {
      const lastElement = document.head.lastElementChild;
      lastElement.insertAdjacentElement('afterend', metaElement);
    }, 5000);
  }
  if (to.matched.length == 0) {
    from.path ? next({ name: from.name }) : next("/notFound");
  } else {
    
    next(); //通过next()还可以解决相同路径不允许重复跳转的问题
  }
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
export default router;
